// extracted by mini-css-extract-plugin
module.exports = {"heading":"WindGraph_heading__CWFpC","windGraph":"WindGraph_windGraph__D9Wcz","windGraphs":"WindGraph_windGraphs__OhuPy"};